/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_a6388797{list-style:none;margin:0;padding:0}"}]);
export const root = "root_a6388797";